<template>
  <div class="notice-edit-container">
    <p class="tit">{{ mode === 'update' ? '编辑更新弹窗' : '编辑通知弹窗' }}</p>

    <div class="title-box">
      <div class="text-wrap" v-show="left && title">
        <!-- <span class="text" :class="{ 'title-href': titleHref }">{{ title }}</span> -->
        <el-popover
          v-model="showPopover"
          trigger="click"
          popper-class="notice-edit-title-href-dialog"
        >
          <el-form ref="form" :model="form">
            <el-form-item label="链接文本">
              <el-input v-model="form.title" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="链接地址">
              <el-input v-model="form.href" placeholder="请输入"></el-input>
            </el-form-item>

            <div class="btn-wrap">
              <span class="btn text-btn-active" @click="showPopover = false">取消</span>
              <wf-button :disabled="!form.title" @click="handleAddHref">确定</wf-button>
            </div>
          </el-form>

          <div slot="reference" class="add-href-btn-wrap" :style="{'left': `${ left }px`}">
            <i class="icon iconfont iconicon_hyperlink"></i>
            添加链接
          </div>
        </el-popover>
      </div>

      <el-input
        type="text"
        placeholder="点击输入主标题"
        v-model="title"
        maxlength="16"
        :class="{'has-href': titleHref}"
        @input="handleInput"
        @blur="handleBlur"
      ></el-input>

      <span class="hide-title" ref="title">{{ title }}</span>
    </div>

    <div class="content-box">
      <Wang-editor
        v-if="showEditor"
        ref="wangEditor"
        :showBtn="false"
        :textInfo="textInfo"
        :toolbarObj="toolbarObj"
        placeholder="请输入正文"
        :showToolbarBorder="false"
        @change="handleChange"
        @editorSubmit="handleUpdateContent"
      ></Wang-editor>
    </div>

  </div>
</template>

<script>
import WangEditor from '@/components/wangEditor/index.vue'

export default {
  components: {
    WangEditor
  },
  props: {
    mode: {
      // 弹窗模式，update为更新弹窗；notice为通知弹窗
      type: String,
      default: 'update'
    },
    param: {
      // 弹窗内容
      type: Object,
      default: () => {
        return {}
      }
    },
    titleHref: {
      // 更新弹窗的标题带的链接
      type: String,
      default: ''
    },
    showEditor: {
      // 是否展示编辑器
      type: Boolean,
      default: true
    }
  },
  watch: {
    param: {
      handler(newObj, oldObj) {
        this.title = newObj.title
        this.form.href = this.titleHref ? this.titleHref : ''
        this.getPosition()

        if (newObj.id) {
          // 编辑状态下
          this.form.title = newObj.title
        }
        // 富文本编辑器回显初始化
        if (newObj.notification_content && ~newObj.notification_content.indexOf('"type":')) {
          this.textInfo = newObj.notification_content
        } else {
          this.textInfo = '[{"type":"paragraph","children":[{"text":""}]}]'
        }
        this.$nextTick(() => {
          this.$emit('handleShowEditor')
        })
      },
      deep: true
    }
  },
  data() {
    return {
      toolbarObj: [
        "headerSelect", // 标题
        "bulletedList", // 无序列表
        "numberedList", // 有序列表
        {
            "key": "group-justify",
            "title": "对齐",
            "iconSvg": "<svg viewBox=\"0 0 1024 1024\"><path d=\"M768 793.6v102.4H51.2v-102.4h716.8z m204.8-230.4v102.4H51.2v-102.4h921.6z m-204.8-230.4v102.4H51.2v-102.4h716.8zM972.8 102.4v102.4H51.2V102.4h921.6z\"></path></svg>",
            "menuKeys": [
                "justifyLeft", // 左对齐
                "justifyRight", // 右对齐
                "justifyCenter", // 居中对齐
                "justifyJustify" // 两端对齐
            ]
        },
        "|",
        "fontSize", // 字体大小
        "fontFamily", // 字体
        "|",
        "bold", // 加粗
        "underline", // 下划线
        "italic", // 斜体
        "color", // 文字颜色
        "|",
        "insertLink", // 插入链接
        "emotion", // 表情
      ],
      showPopover: false, //是否展示标题添加链接窗口
      left: 0, // 添加链接的位置
      form: {
        title: '',
        href: ''
      },
      title: '',
      textInfo: '[{"type":"paragraph","children":[{"text":""}]}]', // 富文本显示已有内容，必须是编辑器的文本结构
    }
  },
  methods: {
    handleInput() {
      this.debounce(() => {
        this.$emit('update', 'title', this.title)
        if (this.mode === 'update') {
          // 更新弹窗，实时更新添加链接按钮的位置
          this.form.title = this.title
          this.getPosition()
        }
      }, 100)
    },
    handleBlur() {
      // if (this.mode === 'notice') return
      // if (!this.title) return
      // this.form.title = this.title
      // this.getPosition()
      // this.showAddHref = true
    },
    // 获取添加链接的位置
    getPosition() {
      // 获取标题的宽度
      if (!this.title || this.mode === 'notice') return
      this.$nextTick(() => {
        const _titleWidth = this.$refs.title.getBoundingClientRect().width
        this.left = _titleWidth + 21
      })
    },
    // 添加标题链接
    handleAddHref() {
      this.showPopover = false
      this.title = this.form.title
      this.getPosition()
      this.$emit('update', 'title', this.title, this.form.href)
    },
    // 富文本编辑器内容发生变化
    handleChange() {
      if (!this.$refs.wangEditor) return
      this.debounce(() => {
        this.$refs.wangEditor.handleSubmit()
      }, 500)
    },
    // 富文本编辑器提交内容
    handleUpdateContent(val, html, text) {
      // console.log(val, html, text)
      this.$emit('update', 'notification_content', val)
    },
    resetFn() {
      this.form = {}
      this.form = {
        title: '',
        href: ''
      }
      this.left = 0
      this.showPopover = false
      this.textInfo = '[{"type":"paragraph","children":[{"text":""}]}]'
    },
    debounce(fn, wait) {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(fn, wait)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";
.notice-edit-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  .tit {
    font-size: 16px;
    font-weight: 500;
    line-height: 18px;
    margin-bottom: 24px;
  }
  .title-box {
    margin-bottom: 8px;
    border-bottom: 1px solid rgba(32, 32, 32, .08);
    position: relative;
    .text-wrap {
      display: flex;
      align-items: center;
      .text {
        font-size: 24px;
        font-weight: 500;
        line-height: 80px;
        &.title-href {
          text-decoration: underline;
        }
      }
      .add-href-btn-wrap {
        z-index: 2;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translate(0, -50%);
        display: flex;
        font-size: 14px;
        color: #2682FF;
        // margin-left: 13px;
        padding: 8px;
        cursor: pointer;
        border-radius: 4px;
        &:hover {
          background: rgba(38, 130, 255, .1);
        }
        &:active {
          background: rgba(38, 130, 255, .18);
        }
        i {
          font-size: 14px;
          margin-right: 5px;
        }
      }
    }
    /deep/ .el-input {
      .el-input__inner {
        height: 80px;
        padding: 0;
        border: none !important;
        font-size: 24px !important;
        line-height: 80px;
        &::placeholder {
          font-size: 24px !important;
          @include fontColorOpacity(.4);
        }
      }
      &.el-input.has-href {
        .el-input__inner {
          text-decoration: underline;
        }
      }
    }
    .hide-title {
      visibility: hidden;
      position: absolute;
      left: 0;
      top: 0;
      font-size: 24px;
      line-height: 80px;
    }
  }
  .content-box {
    height: 0;
    flex: 1;
    /deep/ .editor-wrap {
      height: 100%;
      .editor-con {
        height: 100%;
        border: none;
        display: flex;
        flex-direction: column;
        > div:nth-child(2) {
          height: 0;
          flex: 1;
        }
        .w-e-scroll > div:nth-child(1) {
          padding: 0;
        }
        .w-e-text-placeholder {
          top: 12px;
          left: 0;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.notice-edit-title-href-dialog {
  width: 288px;
  height: 272px;
  background: #fff;
  box-shadow: 0px 4px 16px 0px rgba(13, 31, 60, .16);
  border-radius: 4px;
  border: 1px solid #EAEBEC;
  padding: 28px 24px 24px;
  box-sizing: border-box;
  .el-form {
    .el-input__inner {
      height: 40px;
    }
  }
  .btn-wrap {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .btn {
      margin-right: 24px;
    }
  }
}
</style>
